import { CurrencyPipe } from '@angular/common';
import { getLocaleDefault } from './locale';

export const LOCALE = getLocaleDefault();

export let numericFormat: {
  decimal: Intl.NumberFormat;
  percent: Intl.NumberFormat;
  currency: Intl.NumberFormat;
};

export function initFormat(locale: string) {
  numericFormat = {
    decimal: new Intl.NumberFormat(locale, { style: 'decimal' }),

    percent: new Intl.NumberFormat(locale, {
      style: 'percent',
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    }),

    currency: new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    })
  };
}

export function extendNumericFormat(
  options: Intl.NumberFormatOptions
): Intl.NumberFormat {
  const baseOptions = (
    numericFormat[options.style] || numericFormat.decimal
  ).resolvedOptions();
  options = { ...baseOptions, ...options };

  return new Intl.NumberFormat(baseOptions.locale, options);
}

initFormat(LOCALE);

export const currencyPipe = new CurrencyPipe(LOCALE);
